import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LogService {

  constructor (public http: HttpClient) { }

  addLog (data: any) {
    return this.http.post('/edozzier/portal-addLog.php', data);
  }

  getlogs (params = {}) {
    return this.http.get('/edozzier/portal-getLogs.php', { params });
  }
}
